import * as actionTypes from '../actions/types';

const initialState = {};

// might need to refactor some logic
export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ADD_PERSONA:
      let newPersona = {
        id: action.id,
        name: action.name,
        role: action.role,
        hero: action.hero,
        picUrl: action.picUrl,
      };

      let newPersonas = {};
      const oldPersonas = state;

      if (action.hero) {
        Object.keys(state).forEach((personaId) => {
          newPersonas[personaId] = {
            ...oldPersonas[personaId],
            hero: false,
          };
        });
      }

      newPersonas = action.hero ? newPersonas : state;

      return { ...newPersonas, [action.id]: newPersona };

    case actionTypes.EDIT_PERSONA:
      let editPersonas = {};
      const oldEditPersonas = state;

      if (action.hero) {
        Object.keys(state).forEach((personaId) => {
          editPersonas[personaId] = {
            ...oldEditPersonas[personaId],
            hero: false,
          };
        });
      }

      editPersonas = action.hero ? editPersonas : state;

      return {
        ...editPersonas,
        [action.id]: {
          ...state[action.id],
          name: action.name,
          role: action.role,
          hero: action.hero,
          picUrl: action.picUrl,
        },
      };

    case actionTypes.DELETE_PERSONA:
      const { [action.id]: deletePersona, ...personas } = state;
      return {
        ...personas,
      };

    default:
      return state;
  }
};
